/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import appImg from '../../../assets/bg.png'
import './styles.css';

export function Panel() {
  return (
    <section className="secondHeader">
      <div className="textButtonHeader">
          <h2>Somos a melhor plataforma para encontrar profissionais de saúde perto de você.</h2>
          <p>Conheça nosso aplicativo disponível para<br></br>
            Android</p>

        <div className="buttonHeaderIndex">
          <button  onClick={() => {
      window.open("https://play.google.com/store/apps/details?id=com.buscasaude", "_blank");
    }}  className="buttonGooglePlay"><i className="fab fa-google-play"></i>Google Play</button>
          {/* <button className="buttonIosStore"><i className="fab fa-apple"></i>Apple Store</button> */}
        </div>
        </div>

      <div className="imgHeader2">
        <img src={appImg} alt="Busca Saúde" />
      </div>
    </section>
  )
}